import React, { useEffect } from "react";
import styles from "./News.module.css";
import axios from "axios";
import { Alert } from "@mui/material";

const be_url = process.env.REACT_APP_BACKEND_BASE_URL

function News() {
  const [news, setNews] = React.useState([]);
  const [error, setError] = React.useState(null);

  useEffect(() => {
    axios.get(`${be_url}news/`)
            .then(res => {
                console.log(res);
                if (res.status === 200) {
                    console.log(res.data);
                    setError(null);
                    setNews(res.data.data);
                } else {
                    throw new Error('No results found on this number please try again');
                }
            })
            .catch(error => {
                console.error(error);
                setError(error.message);
            });
  }, []);

  return (
    <div id="features" className={styles.mask}>
      <div className="container mx-auto flex items-center flex-col  py-20 px-5 md:px-0">
        <h1 className="text-lg sm:text-3xl lg:text-5xl text-center text-tertiary font-poppins font-black py-3">
          Latest News
        </h1>
        {error && <Alert severity='error' className="self-center">{error}</Alert>}
        <div className={`w-fit grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 z-10`}>
          {news.map((item, index) => (
            <NewsCard
              key={index}
              image={`${be_url}media/${item.image}`}
              title={item.title}
              // format date should be month day, year
              date={new Date(item.created_at).toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric",
              })
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
}

const NewsCard = ({ image, title, date }) => {
  return (
    <div className="p-6">
      <img src={image} alt={title} className="w-full  object-cover mb-4" />
      <div className="flex items-center">
        <h3 className="text-xl font-semibold text-tertiary">{title}</h3>
      </div>
      <p className="mt-4 text-base text-secondary">{date}</p>
    </div>
  );
};

export default News;
